import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const CARTFUNNELSELECTBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "required",
  "display_title_in_comment",
  "placeholder",
  "radius_type",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartFunnelSelectBlockDescriptor: _generatedCartFunnelSelectBlockDescriptor,
  cartFunnelSelectBlockBlocDefinition,
  cartFunnelSelectBlockDashboardLayout,
  cartFunnelSelectBlockConfig,
  cartFunnelSelectBlockResolveConfig,
  cartFunnelSelectBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart funnel / Select input",
    componentType: "CartFunnelSelectBlockComponent",
    category: "cart",
    description: "Cart funnel / Select input.",
    keywords: [],
    allowedIn: [
      { bloc: "CartFunnelFormBlockComponent", slot: "items" },
    ],
    sharedFields: {},
    slots: [
      {
        key: "options",
        name: "pages.blocks.cart-funnel-select.options.label",
        accept: "explicitOnly",
        allowedTypes: ["CartFunnelSelectOptionBlock"],
        slotItemFormat: "ids",
      },
    ],
  },
  () => ({
    title: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.cart-funnel-select.title.label",
        help: "pages.blocks.cart-funnel-select.title.help",
      },
    }),
    required: propertyValue({
      type: "checkbox",
      value: true,
      options: {
        label: "pages.blocks.cart-funnel-select.required.label",
      },
    }),
    display_title_in_comment: propertyValue({
      type: "checkbox",
      value: true,
      options: {
        label: "pages.blocks.cart-funnel-select.display-title-in-comment.label",
      },
    }),
    placeholder: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.cart-funnel-select.placeholder.label",
      },
    }),
    radius_type: propertyValue({
      type: "select",
      value: "FULL",
      options: {
        label: "pages.blocks.cart-funnel-select.radius-type.label",
        choices: [
          {
            value: "SM",
            label: "pages.blocks.cart-funnel-select.radius-type.options.sm",
          },
          {
            value: "MD",
            label: "pages.blocks.cart-funnel-select.radius-type.options.md",
          },
          {
            value: "LG",
            label: "pages.blocks.cart-funnel-select.radius-type.options.lg",
          },
          {
            value: "FULL",
            label: "pages.blocks.cart-funnel-select.radius-type.options.full",
          },
        ],
      },
    }),
    display_custom_title_in_comment: propertyValue({
      type: "checkbox",
      value: false,
      options: {
        label: "pages.blocks.cart-funnel-select.display-custom-title-in-comment.label",
      },
    }),
    custom_title: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.cart-funnel-select.custom-title.label",
        help: "pages.blocks.cart-funnel-select.custom-title.help",
      },
    }),
  }),
  () => ({
    omitFields: ["display_custom_title_in_comment", "custom_title"] as const,
    tabs: [
      {
        label: "pages.blocks.cart-funnel-select.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-funnel-select.fieldset.field.label",
            fields: [
              "title",
              "placeholder",
              "required",
              "options",
              "radius_type",
            ],
          },
          {
            legend: "pages.blocks.cart-funnel-select.fieldset.order-comment.label",
            fields: ["display_title_in_comment"],
          },
        ],
      },
    ],
  }),
);

export function cartFunnelSelectBlockDescriptor(): IBlockDescriptor;
export function cartFunnelSelectBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartFunnelSelectBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartFunnelSelectBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedCartFunnelSelectBlockDescriptor,
    cartFunnelSelectBlockProperties,
    fieldOrder,
  );
}

export {
  cartFunnelSelectBlockBlocDefinition,
  cartFunnelSelectBlockDashboardLayout,
  cartFunnelSelectBlockProperties,
  cartFunnelSelectBlockConfig,
  cartFunnelSelectBlockResolveConfig,
};

export type CartFunnelSelectBlockConfig = typeof cartFunnelSelectBlockConfig;
